import Header from '../../../__Layout/Header';
import React, { useState } from "react";
import Loader from '../../../utils/Loader';
import { useGetParticipantsQuery, useGetCourseTaskQuery } from "../../../Services/api";
import { pageUrl, pageSize } from "../../../utils/constants/constants";
import "../../../assets/niceapms/assets/css/style.css"
import { Link, useParams } from 'react-router-dom';

export default function Participants() {
    const { course_id, lpid } = useParams();
    const param = course_id + '/' + lpid;
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: getCourseTask,
    } = useGetCourseTaskQuery({ pageUrl, params: course_id });
    const {
        data: getParticipants,
        isLoading: isGetLoading,
    } = useGetParticipantsQuery({ pageUrl, params: { param, page, pageSize } });
    const getPrevious = () => {
        setPage(page - 1);
        setSearch("");
    }
    const getNext = () => {
        setPage(page + 1);
        setSearch("");
    }
    const findSearch = (e) => {
        setPage(0);
        setSearch(e.target.value);
    }
    if (isGetLoading) return <Loader></Loader>
    let count = 1;
    return (
        
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">Course Participants</h5>
                        <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                            <li className="nav-item flex-fill" role="presentation">
                                <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">My Courses/Training</button>
                            </li>
                            <li>
                                <Link to={`/student-course`} className='btn btn-dark pull-right'>
                                    Back
                                </Link>
                            </li>

                        </ul>
                        <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                            <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab">
                                {
                                    getCourseTask?.status === 404 ?
                                    <section className="section">
                                    <div className="row ">
                                        <div className='col-md-12 col-sm-12 col-xs-12 '>
                                            <ul className="d-flex list-unstyled gap-3">
                                                <li>    <Link className="nav-link text-decoration-underline" to={`/course-participants/${course_id}/${lpid}`}><strong>Participants</strong> </Link></li>
                                                <li>    <Link className="nav-link text-decoration-underline" to="#"><strong>Grade</strong> </Link></li>
                                                <li>    <Link className="nav-link text-decoration-underline" to="#"><strong>Competencies</strong></Link></li>
                                            </ul>
                                            <div className='bg-danger text-white p-3'>Not Participants yet</div>
                                            
                                        </div>
                                    </div>
                                </section>
                                : 
                                 <section className="section">
                                    <div className="row ">
                                        <div className='col-md-3 col-sm-6 col-xs-6 card'>
                                            {/* collapse */}
                                            <div className="card p-3"><h4>{getCourseTask?.data[0]?.course?.course_name}</h4></div>
                                            <div className="panel-group p-3" id="accordion">
                                                {
                                                    getCourseTask?.data?.map((item) => {

                                                        return (

                                                            <div className="panel panel-default" key={item.id}>

                                                                <div className="panel-heading">
                                                                    <h4 className="panel-title">
                                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse1">  {item?.start_date &&
                                                                            new Date(item.start_date).toLocaleDateString('en-GB', {
                                                                                day: '2-digit',
                                                                                month: 'long',
                                                                            })} -
                                                                            {item?.start_date &&
                                                                                new Date(item.end_date).toLocaleDateString('en-GB', {
                                                                                    day: '2-digit',
                                                                                    month: 'long',
                                                                                })} </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="collapse1" className="panel-collapse collapse in">
                                                                    <div className="panel-body">
                                                                        {
                                                                            item?.course_task_details?.map((itemD) => {

                                                                                return (
                                                                                    <div key={itemD.id}>
                                                                                        {/* <p><Link  to={`/teacher-questions/${course_id}/${itemD?.id}/${lpid}`}>{itemD?.title}</Link></p> */}
                                                                                        <p><Link  to={`/teacher-questions/${course_id}/${itemD?.id}`}>{itemD?.title}</Link></p>

                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }



                                            </div>
                                            {/* end collapse */}
                                        </div>

                                        <div className='col-md-9 col-sm-12 col-xs-12 '>
                                            <ul className="d-flex list-unstyled gap-3">
                                                <li>    <Link className="nav-link text-decoration-underline" to={`/course-participants/${course_id}/${lpid}`}><strong>Participants</strong> </Link></li>
                                                <li>    <Link className="nav-link text-decoration-underline" to="#"><strong>Grade</strong> </Link></li>
                                                <li>    <Link className="nav-link text-decoration-underline" to="#"><strong>Competencies</strong></Link></li>
                                            </ul>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th className='text-capitalize'>Name</th>
                                                        <th className='text-capitalize'>Role</th>
                                                        <th className='text-capitalize'>Group</th>

                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        getParticipants?.data?.data_array?.map((item) => {

                                                            return (
                                                                <tr key={item.student_id}>
                                                                    <th scope="row">{count++}</th>

                                                                    <td>{item?.student?.first_name}{item?.student?.last_name} </td>
                                                                    <td>{'Student'} </td>
                                                                    <td>{item.participant_group}</td>


                                                                    <td>{item.mobile_number}</td>

                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                            <nav aria-label="Page navigation example">
                                                <ul className="pagination">
                                                    {getParticipants?.data?.currentPage !== 0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> : ''}
                                                    <li className="page-item"> {getParticipants?.data?.currentPage + 1} </li>
                                                    <li className="page-item"> of {getParticipants?.data?.totalPages}</li>
                                                    {getParticipants?.data?.currentPage !== getParticipants?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li> : ''}
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </section>
                                }
                               
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
